module.exports = __webpack_public_path__ + "static/img/app03.80a2906.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app03.png
// module id = A0aA
// module chunks = 1